import mainLogo from '../../images/Provence/provence_logo_color_2.webp';
import squareLogo from '../../images/Provence/provence_logo_color_square.webp';
import mainLogoWhite from '../../images/Provence/provence_logo_white_2.webp';
import banner01 from '../../images/Provence/provence_bannerBg_peugeot_01.webp';
import banner02 from '../../images/Provence/provence_bannerBg_hyundai_01.webp';
import banner03 from '../../images/Provence/provence_bannerBg_citroen_01.webp';
import banner04 from '../../images/Provence/provence_bg_aboutus_01.webp';
import car123 from '../../images/Provence/123_peugeot3008.jpg';
import box123 from '../../images/Provence/123_provence.jpg';
import bannerFreeShippingDesktop from '../../images/Provence/banner_fretegratis_provence_desk.jpg';
import bannerFreeShippingMobile from '../../images/Provence/banner_fretegratis_provence_mobile.jpg';
import bannerFreeShippingFaixaSmall from '../../images/Provence/banner_fretegratis_provence_faixa_small.jpg';
import bannerFreeShippingFaixaSmallMobile from '../../images/Provence/banner_fretegratis_provence_faixa_small_mobile.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Provence',
    defaultStoreLink: 'provenceparts.com.br',
    defaultContactEmail: 'lojaonline@grupoprovence.com.br',
    whatsappNumber: '42 3629 8559',
    CNPJ: '07.681.092/0001-61',
    CNPJname: 'Provence Veiculos S/A',
    CNPJaddress: 'Av. Ernesto Vilela, 1818 - Nova Russia, Ponta Grossa - PR, 84.070-000',
    launchDate: '12/02/2025',

    multiContact: {
        'Citroen/Peugeot': '42 3025 9514',
        'Hyundai': '44 3032 0277',
        'Honda': '42 3629 8559'
    },

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "citroen",
        "peugeot",
        "honda",
        "hyundai",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "LOVAT HYUNDAI - LONDRINA",
        "PROVENCE PEUGEOT-CITROEN",
        "SAIKON HONDA GUARAPUAVA",
    ],

    dealerSites: {
        "LOVAT HYUNDAI - LONDRINA": "https://hyundailovat.com.br/",
        "PROVENCE PEUGEOT-CITROEN": "https://www.grupoprovence.com.br/",
        "SAIKON HONDA GUARAPUAVA": "https://www.hondasaikon.com.br/",
    },

    freeShippingSellers: {
        "LOVAT HYUNDAI - LONDRINA": true,
        "PROVENCE PEUGEOT-CITROEN": true,
        "SAIKON HONDA GUARAPUAVA": true,
    },

    freeShippingCEPs: {
        'SÃO PAULO': [
            ['01000000', '19999999']
        ],
        'MINAS GERAIS': [
            ['30000000', '39999999']
        ],
        'PARANÁ': [
            ['80000000', '87999999']
        ],
        'SANTA CATARINA': [
            ['88000000', '89999999']
        ],
        'RIO GRANDE DO SUL': [
            ['90000000', '99999999']
        ]
    },

    freeShippingRules: {
        minProductPrice: 79.00,
        maxDeliveryPrice: 400.00,
    },

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,
    bannerFreeShippingDesk: bannerFreeShippingDesktop,
    bannerFreeShippingMobile: bannerFreeShippingMobile,
    bannerFreeShippingFaixaSmall: bannerFreeShippingFaixaSmall,
    bannerFreeShippingFaixaSmallMobile: bannerFreeShippingFaixaSmallMobile,
    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Provence</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo Provence é uma referência no estado do Paraná, destacando-se pelo compromisso com a excelência no atendimento ao cliente em todas as suas revendas.',
            'Com uma vasta experiência no setor automotivo, o grupo é composto pelas revendas Citroën Provence, Peugeot Provence, Honda Saikon e Hyundai Lovat. Cada uma das nossas unidades é dedicada a oferecer um serviço de qualidade, combinando conhecimento técnico com um atendimento personalizado e atencioso.',
            'Além das revendas de automóveis, o Grupo Provence também oferece serviços completos de seguros através da Ellure Seguros, proporcionando tranquilidade e segurança para todos os clientes.',
            'O nosso sucesso está fundamentado em uma filosofia de trabalho que prioriza a satisfação do cliente, a transparência nas negociações e a constante busca por inovação.'
        ],
        link: 'https://savol.com.br/sobre/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/gruposavol/',
        Facebook: 'https://www.facebook.com/gruposavol/',
        LinkedIn: 'https://www.linkedin.com/company/savol/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}